import React, { Component } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import mobile from "../assets/mobile.svg";

const mobileRegex = RegExp(/09(0[1-9]|1[0-9]|2[1-9]|3[0-9]|9[0-9])-?[0-9]{7}/);

export default class MobilePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileErrorText: "",
      mobileValue: "",
      buttonText: true,
      buttonSpinner: false,
      buttonDisabled: false,
      actionError: "",
    };
    this.mobileHandleChange = this.mobileHandleChange.bind(this);

    this.mobileInput = React.createRef();
  }

  loginClick = () => {
    this.setState({ actionError: "" });
    let mobile = document.getElementById("mobile");

    if (this.state.mobileValue === "") {
      mobile.setAttribute("style", "border-color: var(--red1) !important");
      this.setState({ mobileErrorText: "لطفاً شماره تلفن خود را وارد کنید" });
      return;
    } else {
      mobile.setAttribute("style", "border-color: #cfcfcf !important");
      this.setState({ mobileErrorText: "" });
    }

    if (mobileRegex.test(this.state.mobileValue)) {
      mobile.setAttribute("style", "border-color: #cfcfcf !important");
      this.setState({ mobileErrorText: "" });
    } else {
      mobile.setAttribute("style", "border-color: var(--red1) !important");
      this.setState({ mobileErrorText: "شماره تلفن وارد شده نامعتبر است" });
      return;
    }

    this.setState({
      buttonText: false,
      buttonSpinner: true,
      buttonDisabled: true,
    });

    let data = {
      mobile: this.state.mobileValue,
    };

    fetch("/api/checkUser", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          sessionStorage.setItem("mobile", this.state.mobileValue);
          this.props.history.push(this.props.match.path + "/Password");
        } else if (result.status === 404) {
          sessionStorage.setItem("mobile", this.state.mobileValue);
          sessionStorage.setItem("userStatus", "signup");
          this.props.history.push(this.props.match.path + "/ValidationCode");
        } else {
          this.setState({
            buttonText: true,
            buttonSpinner: false,
            buttonDisabled: false,
            actionError: "ارتباط با سرور برقرار نشد",
          });
        }
      });
  };

  componentDidMount() {
    this.mobileInput.current.focus();
  }

  mobileHandleChange(event) {
    let telephone = event.target.value;
    if (telephone !== "0" && telephone !== "") {
      if (!Number(telephone)) {
        return;
      }
    }
    this.setState({ mobileValue: event.target.value });
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.loginClick();
    }
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div style={{ minWidth: "260px", maxWidth: "350px", width: "80%" }}>
          <div className="mobile">
            {/* <label htmlFor="mobile">شماره تلفن همراه</label> */}
            <label htmlFor="mobile">ورود به حساب کاربری</label>
            {/* <div style={{display:'flex',flexDirection:'row',backgroundColor:'red'}}>
                        <div style={{minHeight:'100%',display:'flex',justifyContent:'flex-start',alignItems:'center',width:'40px'}}><FontAwesomeIcon style={{minHeight:'25px',minWidth:'20px',margin:'0',padding:'0'}} icon={faMobileAlt} /></div>
                          <Form.Control
                              maxlength="11"
                              className="inputStyle"
                              placeholder="شماره تلفن همراه خود را وارد کنید"
                              type="tel"
                              name="mobile"
                              id="mobile"
                              onChange={this.mobileHandleChange}
                              value={this.state.mobileValue}
                              disabled={this.state.buttonDisabled}
                              onKeyPress={this.handleKeyPress.bind(this)}
                              ref="mobileInput"
                          />
                          
                      </div> */}

            <div className="InputWithIcon">
              <div className="inputImageDiv">
                <img src={mobile} className="inputImage" alt="mobile" />
              </div>
              <Form.Control
                maxLength="11"
                className="inputStyle ltr"
                placeholder="شماره تلفن همراه خود را وارد کنید"
                type="tel"
                name="mobile"
                id="mobile"
                onChange={this.mobileHandleChange}
                value={this.state.mobileValue}
                disabled={this.state.buttonDisabled}
                onKeyPress={this.handleKeyPress.bind(this)}
                ref={this.mobileInput}
              />
            </div>

            <div className="errorMessage">{this.state.mobileErrorText}</div>
          </div>
          <div className="createAccount">
            <Button
              variant="primary"
              id="btnLogin"
              style={{
                width: "40%",
                alignSelf: "flex-end",
                float: "right",
                fontSize: "14px",
                height: "34px",
              }}
              disabled={this.state.buttonDisabled}
              onClick={this.loginClick}
            >
              {this.state.buttonSpinner && (
                <Spinner
                  style={{ color: "white", height: "20px", width: "20px" }}
                  animation="border"
                />
              )}
              {this.state.buttonText && <div>مرحله بعد</div>}
            </Button>
          </div>
          {this.state.actionError !== "" && (
            <div className="errorMessageContainer">
              <div>{this.state.actionError}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
